import { Injectable, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { SVG_ICONS } from './icons';

@Injectable({ providedIn: 'root' })
export class IconRegistryService {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);

  public init(): void {
    const iconIds = Object.keys(SVG_ICONS);

    iconIds.forEach((iconId) => this.addIcon(iconId as keyof typeof SVG_ICONS));
  }

  private addIcon(iconId: keyof typeof SVG_ICONS): void {
    if (!SVG_ICONS[iconId]) {
      console.warn(`Icon "${iconId}" not found in SvgIcons`);
      return;
    }

    const sanitizedSvg: SafeHtml = this.domSanitizer.bypassSecurityTrustHtml(
      SVG_ICONS[iconId].replace(
        'NAMESPACE',
        'xmlns="http://www.w3.org/2000/svg"'
      )
    );

    this.matIconRegistry.addSvgIconLiteral(iconId, sanitizedSvg);
  }
}
